export default __webpack_public_path__ + "static/media/790651340895944734.6fcb2bde.png";